import * as React from "react";
import { CmsComponentSlot, CmsHeadTags } from "@grandvisionhq/bloomreach";
import { Util } from "@grandvisionhq/forms";
import { ErrorMessageProvider, Pages, LoginPage } from "@grandvisionhq/fun-returns";
import { useIntl } from "@grandvisionhq/state";
import { e as errorResponse, g as getQueryParams } from "../error-response.js";
const Page = ({ message, isOrderNumberValid }) => {
  const { getLabel } = useIntl();
  const initialMessage = message ? [
    {
      title: `returns.errors.${message}.title`,
      message: `returns.errors.${message}.message`,
      type: "error"
    }
  ] : void 0;
  return /* @__PURE__ */ React.createElement(ErrorMessageProvider, { initialMessages: initialMessage }, /* @__PURE__ */ React.createElement(
    Pages.PageLayout,
    {
      bottomContainerSlot: /* @__PURE__ */ React.createElement(CmsComponentSlot, { path: "main/bottom-container" })
    },
    /* @__PURE__ */ React.createElement(CmsHeadTags, { title: getLabel("returns.page.login.title"), noIndex: true, noFollow: true }),
    /* @__PURE__ */ React.createElement(LoginPage, { isOrderNumberValid })
  ));
};
Page.getInitialProps = async (context) => {
  const { apolloClient, pathname, query, asPath } = context;
  if (!apolloClient) {
    console.error(`ApolloClient not present in context for page ${pathname}`);
    return errorResponse();
  }
  const { message } = getQueryParams(query, asPath, ["message"]);
  return {
    message,
    isOrderNumberValid: Util.validations.isOrderNumber
  };
};
export {
  Page
};
//# sourceMappingURL=returns.js.map
